'use client';
import React, { useCallback, useEffect, useState } from 'react';
import MapFilter from '../../Map/Filter';
import styled from 'styled-components';
import { Dots } from '../../Pool/styleds';
import ShiberseLoader from '../../Loader/loader';
import useLandMap from '../../../hooks/useLandMap';
import { ToggleMultiSelect } from '../../Map/ToggleMultiSelect';
import LandDetail from '../../Map/LandDetail';
import Map from '../../Map/MapView';
import { useMapContext } from '../../../contexts/map-context';
import { PrimaryButton } from '../../theme/components';
import { useAccount } from 'wagmi';
import { mainNetworkChainId, shibariumChainId } from '../../../constants';
import { useLocale } from 'next-intl';
import Link from 'next/link';
import Image from 'next/image';
import CenterFilter from '../Filter/centerFilter';
import UnsupportedNetwork from '../../atoms/unsupportedNetwork';

const LoadingWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #121212e0;
    z-index: 1000;

     @media (max-width: 768px) {
        top: 15rem;
        width: 100%;
        height: 150px;
        z-index: 1000;
    }
`;

const MapScene = () => {
    const [showClearFilter, setShowClearFilter] = useState(false);
    const { address: account, chain } = useAccount();
    const { state, dispatch } = useMapContext();
    const { landData, landPriceData, isLandDataLoaded } = useLandMap();
    const currentLocale = useLocale();

    const setSelectedInfo = useCallback((newLandInfo: object) => {
        dispatch({ type: 'SET_SELECTED_LAND_INFO', payload: { newLandInfo } });
    }, []);

    const setMapCenterPos = useCallback((newPos: { x: number; y: number }) => {
        dispatch({ type: 'UPDATE_MAP_CENTER_POS', payload: { newPos } });
    }, []);

    const setMapZoomLevel = useCallback((newLevel: number) => {
        dispatch({ type: 'UPDATE_MAP_ZOOM_LEVEL', payload: { newLevel } });
    }, []);

    const setSearchOptions = useCallback((newOptions: any) => {
        dispatch({ type: 'UPDATE_SEARCH_OPTIONS', payload: { newOptions } });
    }, []);

    const handleClearFilters = () => {
        const newOptions = {
            shiboshiZone: false,
            privatehub: false,
            diamond: false,
            platinum: false,
            gold: false,
            silver: false,
            openforbid: false,
            openforminting: false,
            minPos: {
                x: null,
                y: null,
            },
            maxPos: {
                x: null,
                y: null,
            },

            walletAddress: '',

            clearFilters: true
        }

        setSearchOptions(newOptions)
    }

    return (
        <div className='w-screen h-full'>
            {isLandDataLoaded ? (
                <div className='flex justify-between overflow-hidden h-full'>
                    <MapFilter />
                    <CenterFilter />
                    <div className='w-full fixed top-0 left-0 h-full' id="mapContainer">
                        <Map
                            mapCenterPos={state.mapCenterPos}
                            updateMapCenterPos={setMapCenterPos}
                            mapZoomLevel={state.mapZoomLevel}
                            updateMapZoomLevel={setMapZoomLevel}
                            selectedInfo={state.selectedLandInfo}
                            setSelectedInfo={setSelectedInfo}
                            landData={landData}
                            landPriceData={landPriceData}
                            searchOptions={state.searchOptions}
                            clearFilter={showClearFilter}
                            setClearFilter={() => setShowClearFilter(prev => !prev)}
                            multiSelect={state.multiSelect}
                        />
                        {showClearFilter && (
                            <LoadingWrapper>
                                <div className='text-xl mb-4 text-white'>
                                    No Lands were found
                                </div>
                                <PrimaryButton onClick={handleClearFilters}>
                                    Clear Filters
                                </PrimaryButton>
                            </LoadingWrapper>
                        )}
                    </div>
                    <ToggleMultiSelect />
                    {state.selectedLandInfo.length > 0 && <LandDetail />}
                </div>
            ) : (
                <LoadingWrapper>
                    <ShiberseLoader size='40px' />
                    <div className='text-3xl mt-4 text-white'>
                        Loading<Dots></Dots>
                    </div>
                </LoadingWrapper>
            )}
        </div>
    );
};

export default MapScene;